import { useMutation } from '@tanstack/react-query';
import { getUserMineSDK, getUserProductAccess } from '@/apis/admin-api/user';
import { sdkSsoLogin } from '@/apis/tass-api/apiUser';

const sdkLogin = async () => {
  const user = await getUserMineSDK();
  if (!user.id) {
    throw new Error('User ID not found');
  }

  const userData = {
    userId: user.id,
    product: 'TSDK',
  };
  const data = await getUserProductAccess(userData.userId, userData.product);

  // Check if expiresAt is defined and is a string
  if (!data?.expiresAt || typeof data.expiresAt !== 'string' || new Date(data.expiresAt) < new Date()) {
    throw new Error('Invalid TSDK subscription');
  }
};

export const useSdkLogin = (onSuccess?: () => void, onError?: () => void) => {
  return useMutation({
    mutationFn: sdkLogin,
    onSuccess,
    onError,
  });
};

export const useSdkSsoLogin = (onSuccess?: () => void, onError?: () => void) => {
  return useMutation({
    mutationFn: sdkSsoLogin,
    onSuccess,
    onError,
  });
};
